/**
 * Redirect inteligente — Redirige al dashboard según el rol del usuario
 * Exporta: default export
 */
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { CASHIER_ROLES, DELIVERY_ROLES, OPERATIVE_ROLES } from "@/config/roles";

/**
 * Redirige al home según el rol y permisos del usuario autenticado.
 * - Empleados básicos → /mis-tareas
 * - Cajeros/Vendedores → /caja
 * - Domiciliarios/Repartidores → /tienda/pedidos
 * - Supervisores/Gestión → primer módulo disponible según permisos
 * - Admins/Dueños sin acceso al dashboard → primer módulo disponible
 * - Admins/Dueños con acceso → Dashboard
 */
const HomeRedirect = () => {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const role = user.role;

  if (role === "empleado") {
    return <Navigate to="/mis-tareas" replace />;
  }

  if (CASHIER_ROLES.includes(role)) {
    if (user.permissions?.caja === "none") {
      return <Navigate to="/mis-tareas" replace />;
    }
    return <Navigate to="/caja" replace />;
  }

  if (DELIVERY_ROLES.includes(role)) {
    return <Navigate to="/tienda/pedidos" replace />;
  }

  if (role === "mesero") {
    return <Navigate to="/mesas" replace />;
  }

  if (OPERATIVE_ROLES.includes(role) && !CASHIER_ROLES.includes(role)) {
    // Redirigir al primer módulo disponible según permisos
    if (user.permissions?.dashboard !== "none")
      return <Navigate to="/dashboard" replace />;
    if (user.permissions?.caja !== "none")
      return <Navigate to="/caja" replace />;
    if (user.permissions?.inventario !== "none")
      return <Navigate to="/inventario" replace />;
    if (user.permissions?.personal !== "none")
      return <Navigate to="/personal" replace />;
    if (user.permissions?.metricas !== "none")
      return <Navigate to="/metricas" replace />;
    return <Navigate to="/mis-tareas" replace />;
  }

  // Admins / Dueños
  if (user?.permissions?.dashboard === "none" && role !== "dueño") {
    if (user.permissions.caja !== "none")
      return <Navigate to="/caja" replace />;
    if (user.permissions.inventario !== "none")
      return <Navigate to="/inventario" replace />;
    return <Navigate to="/mis-tareas" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default HomeRedirect;
